exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#columnVisible .el-button--medium{font-size:12px}", ""]);

// exports
